export enum MiViewScreen {
  cepActivities = 'Customer Engagement Plan Tactics',
  cepTargets = 'Customer Engagement Plan HCPs',
}
